<nav class="navbar navbar-expand-md navbar-dark w-100">
  <div class="collapse navbar-collapse" id="header-nav">
      <ul class="navbar-nav ml-auto">
          <li class="nav-item">
              <div class="row">
                  <div class="col col-12">
                      <div class="dropdown">
                          <a href="#" class="dropdown-toggle light container-user mt-md-1"  data-toggle="dropdown" role="button" aria-expanded="false">
                            <div class="d-flex justify-content-start align-items-center gap-3 px-0">
                                <span class="d-none d-md-inline">{{userFullName()}}</span>
                                <div><kp-initials></kp-initials></div>
                                <span class="d-inline d-md-none ">{{userFullName()}}</span>
                            </div>  
                          </a>
                          <ul class="dropdown-menu">
                              <li class="dropdown-item dropdown-item__heading py-2 py-md-3">
                                  <span>{{userFullName()}}</span>
                              </li>
                              <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="openModalEditUserDialog()">
                                  Min profil
                              </li>
                              <li class="dropdown-item py-2 py-md-3 dropdown-submenu cursor-pointer" (click)="toggleSubMenu($event)" [permission]="{ area: 'Portal', action: 'change_seller' }">
                                  Byt säljare
                                  <ul class="dropdown-menu sub-menu-a" [class.d-block]="isSubmenuVisible()">
                                      @for(item of portalUsers(); track item.USERID) {
                                        <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="setSelectedPortalUser(item)">
                                            {{item.USERFULLNAME}}
                                        </li>
                                      }
                                  </ul>
                              </li>
                              @if(allowRoleChange() && !isAftermarket()) {
                                <li class="dropdown-item py-2 py-md-3 dropdown-submenu cursor-pointer" (click)="togglePortalPermissionRoles($event)">
                                    <span>
                                        Byt roll (Endast i testmiljö)
                                        @if(loadingRoleChange()) {
                                            <span class="mr-2"><i class="fa-regular fa-spinner fa-pulse"></i></span>
                                        }
                                    </span>
                                    <ul class="dropdown-menu sub-menu-b" [class.d-block]="isPortalPermissionRolesVisible()">
                                      @if(newRole() === '') {
                                        <div class="dropdown-item">
                                          <span class="text-danger">
                                            Vid byte av roll måste du logga ut och in <br />
                                            för att ändringen ska slå igenom.
                                          </span>
                                        </div>
                                      } @else {
                                        <div class="dropdown-item">
                                          <span class="text-danger">
                                            Roll uppdaterad. <br />
                                            Logga ut för att ändringen ska slå igenom.
                                          </span>
                                        </div>
                                      }

                                      @for(item of portalPermissionRoles(); track item.ROLEID) {
                                          <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="setPortalPermissionRoles(item.ROLENAME)">
                                              <span [ngClass]="{'font-weight-bold' : item.ROLENAME  === newRole()}">{{item.ROLENAME}}</span>
                                              @if(item.DESCRIPTION) {
                                                <br>
                                                <small class="text-muted">{{item.DESCRIPTION}}</small>
                                              }
                                          </li>
                                      }
                                    </ul>
                                  </li>
                              }
                              @if(isAssembler()) {
                                <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="routeTo('information')">
                                  Information
                                </li>
                                <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="openModalContactSupport()">
                                  Kontakta support
                                </li>
                              }
                              <li class="dropdown-item py-2 py-md-3 cursor-pointer d-none d-md-inline-block" (click)="logout()">
                                  <span class="text-danger">Logga ut <i class="fa-regular fa-arrow-right-from-bracket ml-2"></i></span>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>

              @if(!isAssembler()) {
                <div class="row" [ngClass]="{'mt-md-2' : isMF(), 'mt-md-3' : !isMF()}">
                    @if(isAftermarket()) {
                      <div class="col col-md-3 col-12">
                        <!--Dummy to equal out columns-->
                      </div>
                    }
                    <div class="col col-md-3 col-12">
                        <div class="dropdown">
                            <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false" (click)="openModalEstimatedDlvWeeks()">
                                <div class="d-flex justify-content-start align-items-center gap-3">
                                    <div><i class="fa-regular fa-calendar-week fa-lg" title="Preliminära leveransveckor"></i></div>
                                    <div class="d-inline d-md-none">Leveransveckor</div>
                                </div>
                            </a>
                        </div>
                    </div>
                    @if(!isAftermarket()) {
                      <div class="col col-md-3 col-12">
                          <div class="dropdown">
                              <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                                <div class="d-flex justify-content-start align-items-center gap-3">
                                    <div><i class="fa-regular fa-gear fa-lg" title="Inställningar"></i></div>
                                    <div class="d-inline d-md-none">Inställningar</div>
                                </div>
                            </a>
                              <ul class="dropdown-menu">
                                  <li class="dropdown-item dropdown-item__heading py-2 py-md-3">
                                      <span>Inställningar</span>
                                  </li>
                                  <li (click)="$event.stopPropagation()" class="dropdown-item py-2 py-md-3 pointer">
                                      <check-box [title]="'Visa priser'" [elementId]="'PriceSetting'" [value]="showPrices()" (onSwitch)="setShowPrices($event)" [justifyContent]="'justify-content-between'" [order]="'title-first'"></check-box>
                                  </li>
                                  <li (click)="$event.stopPropagation()" class="dropdown-item py-2 py-md-3 pointer">
                                      <check-box [title]="'Visa inklusive moms'" [elementId]="'WithVATSetting'" [value]="showWithVAT()" (onSwitch)="setShowVat($event)" [justifyContent]="'justify-content-between'" [order]="'title-first'"></check-box>
                                  </li>
                                  <li (click)="$event.stopPropagation()" class="dropdown-item py-2 py-md-3 pointer">
                                      <check-box [title]="'Visa U-värde'" [elementId]="'UValueSetting'" [value]="showUValue()" (onSwitch)="setShowUValue($event)" [justifyContent]="'justify-content-between'" [order]="'title-first'"></check-box>
                                  </li>
                                  @if(isMF()) {
                                    <li (click)="$event.stopPropagation()" class="dropdown-item py-2 py-md-3 pointer">
                                      <check-box [title]="'Visa mått i bilder'" [value]="showMeasurements()" (onSwitch)="setShowMeasurements($event)" [justifyContent]="'justify-content-between'" [order]="'title-first'"></check-box>
                                    </li>
                                  }
                                  <li class="dropdown-item py-2 py-md-3 li-hover" [permission]="{ area: 'Admin-KP', action: 'manage_company' }">
                                      <a [routerLink]="['/custSetup']">Företagsinställningar</a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                    }

                    @if(!isAftermarket()) {
                      <div class="col col-md-3 col-12">
                          <div class="dropdown">
                              <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                                <div class="d-flex justify-content-start align-items-center gap-3">
                                    <div><i class="fa-regular fa-circle-question fa-lg" title="Hjälp"></i></div>
                                    <div class="d-inline d-md-none">Hjälp</div>
                                </div>
                              </a>
                              <ul class="dropdown-menu">
                                  <li class="dropdown-item dropdown-item__heading  py-2 py-md-3">
                                      <span>Hjälp</span>
                                  <li class="dropdown-item py-2 py-md-3 cursor-pointer" (click)="openModalContactSupport()">
                                      Kontakta support
                                  </li>
                                  <li class="dropdown-item py-2 py-md-3 li-hover">
                                      <a [routerLink]="['/notifications']">Notifieringar</a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                    }

                    <div class="col col-md-3 col-12 d-inline d-md-none">
                        <div class="dropdown">
                            <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false" (click)="logout()">
                                <div class="d-flex justify-content-start align-items-center gap-3">
                                    <div><i class="fa-regular fa-arrow-right-from-bracket fa-lg text-danger" title="Logga ut"></i></div>
                                    <div class="d-inline d-md-none">Logga ut</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
              }
          </li>
      </ul>
    </div>
</nav>

<ng-template #editUserProfileTemplate>
  <user-setup [userToEditID]="''"
              [contactToConvertID]="'0'"
              [custAccountToConvert]="''"
              [modalId]="userProfileModalId">
  </user-setup>
</ng-template>

<ng-template #contactSupportTemplate>
  <contact-support [modalId]="contactSupportModalId"></contact-support>
</ng-template>

<ng-template #estimatedDeliveryWeeksTemplate>
  <estimated-delivery-weeks [modalId]="estimatedDeliveryWeeksModalId"></estimated-delivery-weeks>
</ng-template>
